import React from 'react';
import {
  AlertTriangle, Ban, Briefcase, Eye, FileWarning, Gauge, ListChecks, Lock, ShieldAlert, UserX,
} from 'lucide-react';

export const NIVEL_COLOR = {
  'CRÍTICO': 'bg-red-600 text-white',
  ALTO: 'bg-orange-500 text-white',
  MEDIO: 'bg-amber-400 text-amber-950',
  BAJO: 'bg-lime-200 text-lime-900',
  'MUY BAJO': 'bg-emerald-100 text-emerald-800',
};

const Indicador = ({ icono: Icono, label, valor, activo, testid, tono = 'slate' }) => {
  const tonos = {
    slate: 'border-slate-200 bg-white text-slate-600',
    red: 'border-red-200 bg-red-50 text-red-700',
    amber: 'border-amber-200 bg-amber-50 text-amber-800',
    sky: 'border-sky-200 bg-sky-50 text-sky-800',
  };
  return (
    <div className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-xs ${activo ? tonos[tono] : tonos.slate}`} data-testid={testid}>
      <Icono size={14} className={activo ? '' : 'text-slate-300'} />
      <span className={activo ? 'font-semibold' : 'text-slate-400'}>{label}</span>
      {valor !== undefined && <span className="ml-auto font-mono font-bold">{valor}</span>}
    </div>
  );
};

export const ScoreChip = ({ score, testid = 'score-chip' }) => (
  <div className="flex items-center gap-2" data-testid={testid}>
    <Gauge size={16} className="text-slate-500" />
    <span className="text-2xl font-bold tabular-nums text-slate-900">{score?.score ?? '—'}</span>
    <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${NIVEL_COLOR[score?.nivel] || 'bg-slate-100 text-slate-600'}`}>
      {score?.nivel || 'Sin dato'}
    </span>
  </div>
);

// B1: franja de riesgo de la ficha del cliente.
export const ClienteFranjaRiesgo = ({ franja }) => {
  if (!franja) return null;
  return (
    <div className="mb-6 rounded-xl border border-slate-200 bg-slate-50/60 p-4" data-testid="cliente-franja-riesgo">
      <div className="flex flex-wrap items-center gap-6">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">Score de riesgo</p>
          <ScoreChip score={franja.score} testid="cliente-score" />
          <p className="mt-0.5 text-[10px] text-slate-400">
            {franja.score?.episodios_que_suman || 0} episodios suman · {franja.score?.episodios_descartados || 0} descartados
          </p>
        </div>
        <div className="grid flex-1 grid-cols-2 gap-2 md:grid-cols-3 xl:grid-cols-5">
          <Indicador icono={AlertTriangle} label="Alertas 30 días" valor={franja.alertas_30d} activo={franja.alertas_30d > 0} tono="amber" testid="franja-alertas-30d" />
          <Indicador icono={Briefcase} label="Casos abiertos" valor={franja.casos_abiertos} activo={franja.casos_abiertos > 0} tono="amber" testid="franja-casos-abiertos" />
          <Indicador icono={FileWarning} label={franja.tiene_ros ? 'Tiene ROS' : 'Sin ROS'} activo={franja.tiene_ros} tono="red" testid="franja-ros" />
          <Indicador icono={Lock} label={franja.bloqueado ? 'Bloqueado' : 'No bloqueado'} activo={franja.bloqueado} tono="red" testid="franja-bloqueado" />
          <Indicador icono={Eye} label={franja.en_vigilancia ? 'En vigilancia' : 'Sin vigilancia'} activo={franja.en_vigilancia} tono="sky" testid="franja-vigilancia" />
          <Indicador icono={ShieldAlert} label={franja.pep ? 'PEP' : 'No PEP'} activo={franja.pep} tono="red" testid="franja-pep" />
          <Indicador icono={Ban} label={franja.cuit_vigilado ? 'CUIT vigilado' : 'CUIT no vigilado'} activo={franja.cuit_vigilado} tono="red" testid="franja-cuit-vigilado" />
          <Indicador icono={ListChecks}
            label={franja.lista_blanca ? (franja.lista_blanca_todos ? 'Lista blanca (todos)' : `Lista blanca (${franja.lista_blanca_monitores.length})`) : 'Sin lista blanca'}
            activo={franja.lista_blanca} tono="sky" testid="franja-lista-blanca" />
          <Indicador icono={UserX} label={franja.eliminado_waya ? 'Eliminado en Waya' : 'Activo en Waya'} activo={franja.eliminado_waya} tono="red" testid="franja-eliminado-waya" />
        </div>
      </div>
    </div>
  );
};

export default ClienteFranjaRiesgo;
